export default __webpack_public_path__ + "static/fried-egg-dd7a5ff240d1a568cba7ee8a6f3f0162.png";